<template>
	<div class="addzz">
		<el-dialog 
			class="zzgk"
			:modal-append-to-body='true'
			width="500px"
			center
			:append-to-body='true'
			@close="openWin(false)"
			:visible="addPersonWin">
			<div slot="title" class="addtitle">
				<div>
					<i class="icon adddzz"></i>
					{{title}}
					<div class="addline"></div>
				</div>
			</div>
			<div class="formWrap">
				<el-form ref="formData" :model="formData" :rules="rules" class="formWrap" label-width="150">
					<el-form-item label="姓名" class="form_item form_item1" prop="uid">
						<el-cascader
						v-model="formData.uid"
						ref="cascaderAddr"
						:options="zzlist"
						collapse-tags
						filterable
						:getCheckedNodes="true"
						placeholder="请选择候选人"
						clearable></el-cascader>
					</el-form-item>
					<el-form-item label="时间" class="form_item form_item1" prop="year">
						<el-date-picker
							v-model="formData.year"
							type="year"
							placeholder="请选择评选年度"
							value-format="yyyy">
						</el-date-picker>
					</el-form-item>
					<el-form-item class="form_item form_item1" label="材料" prop="file">
						<el-upload
							name="file"
							:action="$uploadFile"
							:on-success="success"
							:before-upload="$limitFile">
							<el-button type="primary">选择文件</el-button>
						</el-upload>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submit()">保 存</el-button>
				<el-button @click="openWin(false)">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { Message } from 'element-ui'
	import { dwgl } from '@/axios'
	import { bsid } from '@/common/common.js'
	let that;
	export default{
		data() {
			return{
				title:'添加候选人',
				formData:{
					user_id:"",
					year:"",
					files:[],
					uid:"",
					status:1,//1:优秀党员 2:党务工作者
				},
				zzlist:[],
				rules:{
					uid:[{ required: true, message: '请输入候选人姓名', trigger: 'blur' }],
					year:[{ required: true, message: '请选择评选年度', trigger: 'blur' }],
				},
				addPersonWin:false,
				type:'add'//新增  编辑
			}
		},
		props:{
			user_id:{
				type:String,
				default:""
			},
			flag:{
				type:String,
				default:""
			},
		},
		created(){
			that = this;
		},
		methods:{
			// 弹窗显示隐藏open:true /false
			openWin(open){
				console.log(open)
				that.addPersonWin = open;
				// that.organMember();
				if(!open){
					that.clearForm();
				}
			},
			// 表单清空
			clearForm(){
				that.addPersonWin = false;
				that.formData = {
					user_id:"",
					year:"",
					files:[],
					uid:"",
					status:1,//1:优秀党员 2:党务工作者
				}
				that.$emit("dataList")
			},
			submit(){
				that.$refs.formData.validate(valid => {
					if(valid){
						that.formData.uid = that.formData.uid[that.formData.uid.length-1];
						that.formData.user_id = that.user_id;
						if(that.type == 'add'){
							//新增 
							dwgl.addGoodMember(that.formData).then(res => {
								if(res.code == 200){
									that.openWin(false);
								}
							})
						}else{
							//编辑
						}
					}
				})
			},
			// 上传封成功
			success(res, file) {
				if(res.code == 200){
					let data = {
						title:res.data.title,
						bsid:bsid(res.data.src),
						ment_url:res.data.src
					}
					that.formData.files.push(data)
				}else{
					Message.error("上传失败")
				}
			},
			// 参与组织列表
			organMember(){
				dwgl.organMember({
					flag:that.flag,
					user_id:that.user_id,
				}).then(res => {
					that.zzlist = res.data;
					console.log(res.data)
				})
			}
		}
	}
</script>

<style lang="scss">
	.form_item1{
		display: flex !important;
		justify-content: center !important;
	}
</style>
